function SvgComponent(props: any) {
    return (
      <svg
        width={164}
        height={96}
        viewBox="0 0 164 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M106.137 86.5a9.5 9.5 0 01-9.5 9.5h-30a9.5 9.5 0 010-19h.24a9.778 9.778 0 01-5-8.535c0-5.402 4.379-9.78 9.78-9.78h-34.52c-5.402 0-9.78-4.38-9.78-9.781 0-5.402 4.378-9.781 9.78-9.781h37.964c-5.398-.005-9.772-4.382-9.772-9.781 0-5.402 4.379-9.78 9.78-9.78H26.782c-5.402 0-9.78-4.38-9.78-9.782C17 4.38 21.378 0 26.78 0h78.247c5.401 0 9.78 4.379 9.78 9.78 0 5.402-4.379 9.781-9.78 9.781h27.616c5.402 0 9.781 4.38 9.781 9.781 0 5.402-4.379 9.78-9.781 9.78h-13.799c5.397.005 9.772 4.383 9.772 9.782 0 5.401-4.379 9.78-9.781 9.78h34.52c5.402 0 9.781 4.38 9.781 9.781 0 5.402-4.379 9.781-9.781 9.781h-52.012a9.497 9.497 0 014.793 8.254z"
          fill="#EDFFF5"
        />
        <circle cx={134} cy={5.99951} r={2} fill="#D9D9D9" />
        <circle cx={43} cy={72.9995} r={2} fill="#D9D9D9" />
        <path
          d="M151.703 47.853l-.203-.28-.203.28-2.165 3-.286.396h5.308l-.286-.396-2.165-3zM3.717 12.874L3.5 12.5l-.217.375-2.165 3.75L.902 17h5.196l-.216-.375-2.165-3.75z"
          stroke="#D9D9D9"
          strokeWidth={0.5}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M110.289 18.225A1.5 1.5 0 01111 19.5v45a1.5 1.5 0 01-1.5 1.5h-9a1.5 1.5 0 01-1.5-1.5V60h-3v4.5a1.5 1.5 0 01-1.5 1.5h-27a1.5 1.5 0 01-1.5-1.5V48a1.5 1.5 0 011.026-1.422L84 40.92V31.5a1.5 1.5 0 01.828-1.341l24-12a1.5 1.5 0 011.461.066zM84 44.082L69 49.08V63h15V44.082zM87 63h6v-4.5a1.5 1.5 0 011.5-1.5h6a1.502 1.502 0 011.5 1.5V63h6V21.927l-21 10.5V63z"
          fill="#27AE60"
        />
        <path
          d="M72 51h3v3h-3v-3zm6 0h3v3h-3v-3zm-6 6h3v3h-3v-3zm6 0h3v3h-3v-3zm12-12h3v3h-3v-3zm6 0h3v3h-3v-3zm-6 6h3v3h-3v-3zm6 0h3v3h-3v-3zm6-6h3v3h-3v-3zm0 6h3v3h-3v-3zM90 39h3v3h-3v-3zm6 0h3v3h-3v-3zm6 0h3v3h-3v-3zm-12-6h3v3h-3v-3zm6 0h3v3h-3v-3zm6 0h3v3h-3v-3zm0-6h3v3h-3v-3z"
          fill="#27AE60"
        />
      </svg>
    )
  }
  
  export default SvgComponent
  